import { SETTINGS_FILTERS } from 'utils/constants';
import { useProjectTasksTable } from '../hooks/useProjectTasksTable';
import TasksTable from '../TasksTable/TasksTable';
import ActionsNotificationsList from 'Pages/TaskDetailPage/ActualHoursModal/ActionsNotificationsList/ActionsNotificationsList';

const TeamTasks = () => {
  const {
    tasks,
    canFetchMoreTasks,
    totalCount,
    filters,
    isLoading,
    handleFetchMoreTasks,
    handleUpdateFilters,
    handleSearchFilterChange,
    handleExportTasks,
    handleReorderTask,
    SnackbarNotification,
    isNotificationVisible,
    snackbarProps,
    hasAppliedFilters,
    refreshTasks,
  } = useProjectTasksTable({
    tableType: SETTINGS_FILTERS.PROJECT_TEAM_TASKS_TABLE,
    supportsReordering: true,
  });

  return (
    <>
      <TasksTable
        tableName={SETTINGS_FILTERS.PROJECT_TEAM_TASKS_TABLE}
        tasks={tasks}
        canFetchMoreTasks={canFetchMoreTasks}
        fetchMoreTasks={handleFetchMoreTasks}
        totalCount={totalCount}
        canReorderTasks
        reorderTask={handleReorderTask}
        filters={filters}
        onUpdateFilters={handleUpdateFilters}
        onExport={handleExportTasks}
        onSearchFilterChange={handleSearchFilterChange}
        refreshTasks={refreshTasks}
        isLoading={isLoading}
        hasAppliedFilters={hasAppliedFilters}
      />

      <ActionsNotificationsList />
      {isNotificationVisible && snackbarProps && (
        <SnackbarNotification {...snackbarProps} />
      )}
    </>
  );
};

export default TeamTasks;
